import {
  Box,
  Container,
  Heading,
  Stack,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"
import { TestimonialContent } from "./content"
import { TestimoniesList } from "./testimonies-list"
import {
  Testimonial,
  TestimonialAvatar,
  TestimonialHeading,
  TestimonialText,
} from "./testimony"

export const TestimoniesComponent = () => {
  const renderTestimonies = () => {
    return TestimoniesList.map((testimony) => {
      return (
        <Testimonial>
          <TestimonialContent>
            <TestimonialHeading>{testimony.title}</TestimonialHeading>
            <TestimonialText>{testimony.text}</TestimonialText>
          </TestimonialContent>
          <TestimonialAvatar
            src={testimony.avatar}
            name={testimony.name}
            title={testimony.job}
          />
        </Testimonial>
      )
    })
  }

  return (
    <Box bg={useColorModeValue("gray.100", "gray.700")}>
      <Container maxW={"7xl"} py={16} as={Stack} spacing={12}>
        <Stack spacing={0} align={"center"}>
          <Heading textAlign={"center"}>Feedbacks from other partners</Heading>
        </Stack>
        <Stack
          direction={{ base: "column", md: "row" }}
          spacing={{ base: 10, md: 4, lg: 10 }}
          flexWrap={"wrap"}
          justifyContent={"center"}
        >
          {renderTestimonies()}
        </Stack>
      </Container>
    </Box>
  )
}
